import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { deployment } from "../../environments/environment";
import { ReviewSessionService } from "../_services/review-session.service";

/**
 * Attaches the short-lived reviewer session token as an `X-Review-Token` header
 * (#226 Phase 7).
 *
 * The header is added ONLY when {@link ReviewSessionService.isReviewerMode} holds
 * AND the request targets the backend API (its URL starts with the configured
 * backend base path, `deployment.backendPath`). It is therefore never attached to
 * `assets/…`, the mzTab validator, the search/data-importer services, or any
 * cross-origin URL — those do not start with the backend base path.
 *
 * A reviewer is anonymous with respect to Keycloak, so `AuthInterceptor` adds no
 * bearer token; the two interceptors coexist without conflict.
 */
@Injectable()
export class ReviewTokenInterceptor implements HttpInterceptor {
  private reviewSession = inject(ReviewSessionService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.reviewSession.isReviewerMode() && this.isBackendApiRequest(req.url)) {
      const token = this.reviewSession.getToken();
      if (token) {
        req = req.clone({
          headers: req.headers.set("X-Review-Token", token),
        });
      }
    }
    return next.handle(req);
  }

  /** True for same-origin backend API calls (never assets/validator/cross-origin). */
  private isBackendApiRequest(url: string): boolean {
    return url.startsWith(deployment.backendPath);
  }
}
